export const styles = (theme) => ({
  root: {
    padding: "1.5rem",
  },

  formControl: {
    "@media screen and (min-width: 400px)": {
      marginBottom: "22.31%",
    },
  },

  formLabel: {
    marginBottom: "10.97%",
    textTransform: "capitalize",
    fontSize: "16px",
    // display: 'flex',
    alignItems: "center",
  },

  label: {
    height: 20,
    marginBottom: 12,
    marginRight: 0,
    textTransform: "capitalize",
  },

  containerExp: {
    display: "flex",
    alignItems: "center",
    background: "#f4f4f4",
    height: 40,
    position: "relative",
    width: "100%",
    marginLeft: -17,

    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      marginTop: "3.624%",
      display: "flex",
      alignItems: "center",
      background: "#f4f4f4",
      height: 30,
      position: "relative",
    },
  },
  square: {
    width: 118,
    height: 40,
    background: "red",
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      width: 118,
      height: 30,
      background: "red",
    },
  },
  arrowRight: {
    "@media only screen and (min-width:600.98px) ": {
      width: 0,
      height: 0,
      borderTop: "20px solid transparent",
      borderBottom: "20px solid transparent",
      borderLeft: "20px solid red",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      borderTop: "15px solid transparent",
      borderBottom: "15px solid transparent",
      borderLeft: "15px solid red",
    },
  },

  titleLeft: {
    "@media screen and (min-width: 1440px)": {
      position: "absolute",
      top: "50%",
      left: "6%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
    "@media screen and (min-width: 1280px) and (max-width: 1439.98px)": {
      position: "absolute",
      top: "50%",
      left: "8%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
    "@media only screen and (min-width:1024.98px) and (max-width:1280px) and (orientation:landscape)": {
      position: "absolute",
      top: "50%",
      left: "6%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
    "@media only screen and (min-width:480px) and (max-width:1024px) ": {
      position: "absolute",
      top: "50%",
      left: "10%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
  },
  titleRight: {
    "@media screen and (min-width: 1200px)": {
      marginLeft: 12,
    },
    "@media only screen and (min-width:768.98px) and (max-width:1024px)": {
      fontSize: "0.875rem",
      marginLeft: 17,
    },
    "@media only screen and (min-width:480px) and (max-width:768px)": {
      fontSize: "0.75rem",
      marginLeft: 17,
    },
  },
  nameModule: {
    textTransform: "capitalize",
  },
  link: {
    textDecoration: "underline",
    cursor: "pointer",
  },
  paperWidthSm: {
    width: "80%",
    maxWidth: "unset",
  },
  marginCloseButton: {
    marginTop: 4,
    minWidth: 45,
  },
  rootDialogContent: {
    padding: "0% 3.8542%",
  },
  rootDialogActions: {
    margin: 0,
    position: "absolute",
    top: "0%",
    right: "0%",
  },
  title: {
    padding: 0,
    fontSize: "1.2rem",
    textTransform: "capitalize",
    fontWeight: "500",
    lineHeight: "normal",
    height: "3rem",
    color: "#000000",
    fontWeight: 900,
  },
  DialogContent: {
    padding: "0 0.5rem",
  },
  wrapButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  topBar: {
    height: "3rem",
    backgroundColor: "rgba(177, 178, 181, 0.25)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  topBarLeft: {
    display: "flex",
    alignItems: "center",
  },
  topBarRight: {
    display: "flex",
    alignItems: "center",
  },
  arrowPackage: {
    width: 0,
    height: 0,
    borderTop: "1.5rem solid transparent",
    borderBottom: "1.5rem  solid transparent",
    // borderLeft: '1.5rem  solid #eebe00'
  },
  packageName: {
    width: "5rem",
    height: "3rem",
    // backgroundColor: '#eebe00',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  packageName_gold: {
    backgroundColor: "#eebe00",
  },
  arrowPackage_gold: {
    borderLeft: "1.5rem  solid #eebe00",
  },
  packageName_basic: {
    backgroundColor: "#1ea000",
  },
  arrowPackage_basic: {
    borderLeft: "1.5rem  solid #1ea000",
  },
  packageName_bronze: {
    backgroundColor: "#f37f00",
  },
  arrowPackage_bronze: {
    borderLeft: "1.5rem  solid #f37f00",
  },
  packageName_silver: {
    backgroundColor: "#9497a3",
  },
  arrowPackage_silver: {
    borderLeft: "1.5rem  solid #9497a3",
  },
  packageName_custom: {
    backgroundColor: "#3F98FF",
  },
  arrowPackage_custom: {
    borderLeft: "1.5rem  solid #3F98FF",
  },
  notification: {
    marginLeft: "1rem",
    marginRight: "0.5rem",
  },
  expiredDays: {
    fontWeight: "bold",
    marginRight: "1rem",
    marginLeft: "1rem",
  },
  containerExpired: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  colorButtonViewReport: {
    backgroundColor: "#292f48",
    width: "90%",
    "&:hover": {
      backgroundColor: "black",
    },
  },
  button: {
    minWidth: "8rem",
    margin: "0.5rem",
  },

  marginCloseButton: {
    marginTop: 4,
    minWidth: 45,
  },
  rootDialogActions: {
    margin: 0,
    position: "absolute",
    top: "0%",
    right: "0%",
  },
  paperWidthSm: {
    width: "80%",
    maxWidth: "unset",
  },
  DialogTitle: {
    textAlign: "center",
  },
  titlePopup: {
    fontSize: "2rem",
    fontWeight: 500,
  },
  group: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    textTransform: "capitalize",
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    padding: "1.5rem 1.5rem 0 1.5rem",
  },
  formControlPopup: {
    width: "60%",
  },
  link: {
    cursor: "pointer",
    textDecoration: "underline",
    marginLeft: "1rem",
  },
  containerPicker: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "0 1.5rem",
  },
  titlePicker: {
    fontSize: "1rem",
  },
});
